import cx from 'classnames'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import useOpenConferenceCall from 'features/ConferenceCall/hooks/useConferenceCall'
import { toggleJoinGroupBeforeActionConfirmBox } from 'store/actions/confirmBox'
import { useGetGroupQuery } from 'store/api/yay/group'
import { useGetActiveCallQuery } from 'store/api/yay/post'
import { useCurrentUser } from 'store/api/yay/user'
import { CallJoinableMode, GroupCallJoinableMode } from 'lib/_types'

import AvatarHorizontalList from 'components/Avatar/AvatarHorizontalList'
import GroupImage from 'features/Group/GroupImage'

import './style.scss'

const UserActiveCallPopup = ({ userId }: { userId: number }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { openConferenceCall } = useOpenConferenceCall()
  const { data: currentUser } = useCurrentUser()

  const activeCallRes = useGetActiveCallQuery({ userId })
  const groupRes = useGetGroupQuery(
    { groupId: activeCallRes?.data?.group?.id?.toString?.() },
    { skip: !activeCallRes?.data?.group?.id }
  )

  const { group, conference_call: conferenceCall } =
    activeCallRes?.data?.post ?? {}

  if (
    !activeCallRes?.isSuccess ||
    !activeCallRes?.data ||
    !conferenceCall ||
    group?.is_private ||
    [
      CallJoinableMode.Noone,
      CallJoinableMode.InviteOnly,
      GroupCallJoinableMode.Noone,
      GroupCallJoinableMode.InviteOnly,
    ].includes(conferenceCall?.joinable_by) ||
    (conferenceCall.joinable_by !== CallJoinableMode.Anyone && !currentUser)
  ) {
    return null
  }

  return (
    <div className="UserActiveCallPopup__wrapper">
      <div
        className="UserActiveCallPopup"
        role="button"
        onClick={() => {
          if (groupRes?.data && !groupRes?.data?.is_joined) {
            dispatch(
              toggleJoinGroupBeforeActionConfirmBox(
                groupRes?.data?.id?.toString?.()
              )
            )
            return
          }

          // Open conference call if user hasn't in the call.
          if (
            !(conferenceCall?.conference_call_users || [])
              .map(({ id }) => id)
              .includes(currentUser?.id)
          ) {
            openConferenceCall({
              conferenceCallId: conferenceCall?.id?.toString?.(),
            })
          }
        }}
      >
        {typeof group !== 'undefined' ? (
          <>
            <GroupImage
              className="UserActiveCallPopup__group_thumbnail"
              group={group}
            />

            <h4 className="UserActiveCallPopup__title">
              {t('user_active_call_popup.group.title')}
            </h4>

            <div className="UserActiveCallPopup__group_topic">
              {group?.topic}
            </div>
          </>
        ) : (
          <>
            <div
              className={cx(
                'UserActiveCallPopup__call_type',
                `UserActiveCallPopup__call_type--${conferenceCall?.call_type}`
              )}
              role="img"
            />

            <h4 className="UserActiveCallPopup__title">
              {t('common.join_us')}
            </h4>

            <AvatarHorizontalList
              className="UserActiveCallPopup__user_list"
              users={conferenceCall?.conference_call_users}
              totalVisible={5}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default UserActiveCallPopup
